import request from '../utils/request';

export function signIn(params) {
  return request({
    url: '/auth/signIn',
    method: 'post',
    data: params,
    skipAuthRefresh: true,
  });
}

export function signOut() {
  return request({
    url: '/auth/logout',
    method: 'post',
  });
}

export async function refresh(refreshToken) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);

  try {
    const response = await fetch(`${process.env.REACT_APP_URL_API}auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
      signal: controller.signal,
    });

    if (!response.ok) {
      const error = new Error(response.statusText);
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } finally {
    // Both refresh callers hold auth_refresh_lock until this promise settles
    clearTimeout(timeout);
  }
}
